import React, { Component } from "react";
import { s360ConfigService } from "../../Services/S360Config";
import dayjs from "dayjs";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import StarRatingComponent from "react-star-rating-component";

class MessageA79 extends Component {
  constructor(props) {
    super(props);
    this.messageRef = React.createRef();
    this.state = { rating: 0, prevRating: 0 };
  }
  onStarClick(nextValue, prevValue, name) {
    const ratingEnum = (value) => {
      switch (value) {
        case 1:
          return "Worst";
          break;
        case 2:
          return "Bad";
          break;
        case 3:
          return "Ok";
          break;
        case 4:
          return "Good";
          break;
        case 5:
          return "Excellent";
          break;
        default:
          return "Excellent";
      }
    };

    this.setState({ rating: nextValue, prevRating: nextValue });

    const ref = this.messageRef.current;

    this.props.actions.sendMessage(ratingEnum(nextValue));
  }
  onStarHover(e) {
    console.log(e);
    this.setState({ rating: e });
  }
  onStarHoverOut(nextvalue) {
    this.setState({ rating: this.state.prevRating });
  }

  //   onStarHover(nextValue,prevValue){
  //       this.setState({rating: nextValue});
  //   }
  //   onStarHoverOut(nextValue,prevValue){
  //       this.setState({rating: nextValue});
  //   }

  render() {
    const { rating } = this.state;

    //         1 - Worst
    // 2 - Bad
    // 3 - Ok
    // 4 - Good
    // 5 - Excelent

    return (
      <div className="s360-message-cotainer-received">
        <div
          className="s360-message-box-custom-a14-received"
          style={this.messageBoxStyle()}
        >
          <h5 style={{ fontWeight: 700 }}>Please share your experience!</h5>
          <div style={{ fontSize: 30 }}>
            <StarRatingComponent
            disabled={this.props.disabled}
              onStarHover={(e) =>
                this.onStarHover(e)
              } /* on icon hover handler */
              onStarHoverOut={(e) =>
                this.onStarHoverOut(e)
              } /* on icon hover out handler */
              name="rate1"
              starCount={5}
              value={rating}
              onStarClick={this.onStarClick.bind(this)}
              starColor={"yellow"}
              emptyStarColor={"#d3d8f5"}
              size={10}
            />
          </div>
        </div>
      </div>
    );
  }
  onChangeHandler = (e) => {
    if (e.target.value !== "") {
      this.props.scrollToLatest();
      this.setState({ value: false });
    } else {
      this.setState({ value: true });
    }
  };
  onMouseEnterButton = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color = isNullOrUndefined(
      designDetails.buttonHighlightTextColor
    )
      ? "#f8f5f5"
      : designDetails.buttonHighlightTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonHighlightBackgroundColor
    )
      ? "#2935dd"
      : designDetails.buttonHighlightBackgroundColor;
  };

  onMouseLeaveButton = (e) => {
    if (!e.target) {
      return;
    }
    // if (e.target.disabled === true) { return }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color = isNullOrUndefined(designDetails.buttonTextColor)
      ? "#0092ed"
      : designDetails.buttonTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonBackgroundColor
    )
      ? "#fff"
      : designDetails.buttonBackgroundColor;
  };

  messageBoxStyle = () => {
    return {
      background: s360ConfigService.config.designDetails.senderMessageColor,
      fontFamily: s360ConfigService.config.designDetails.SenderMessageFont,
      fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize,
      color: s360ConfigService.config.designDetails.senderMessageFontColor,
    };
  };

  formInputBoxStyle = () => {
    return {
      borderColor: s360ConfigService.config.designDetails.headerColor,
      color: s360ConfigService.config.designDetails.buttonTextColor,
      backgroundColor:
        s360ConfigService.config.designDetails.pageBackgroundColor,
      fontWeight: 500,
    };
  };

  onInputKeyPress = (e) => {
    if (e.key === "Enter") {
      this.messageRef &&
        this.messageRef.current &&
        this.messageRef.current.blur();
      const ref = this.messageRef.current;
      this.onMouseLeaveButton(e);
      if (ref.value.trim().length > 0) {
        this.props.actions.sendMessage(ref.value.trim());
      }
    }
  };

  onClickInput = (item) => {
    this.setState({ value: false });
  };

  onInputOut = () => {
    let value =
      this.messageRef &&
      this.messageRef.current &&
      this.messageRef.current.value &&
      this.messageRef.current.value.trim();
    // if (value) {
    //     this.props.actions.sendMessage(value);
    // }
    //this.setState({value: value});
  };

  onSubmit = (e) => {
    //  this.setState({value: false});
    // let value = this.messageRef && this.messageRef.current && this.messageRef.current.value && this.messageRef.current.value.trim();
    const ref = this.messageRef.current;
    //  this.onMouseLeaveButton(e);

    this.props.actions.sendMessage(this.state.rating);
  };

  messageBoxSubmitStyle = () => {
    const designDetials = s360ConfigService.config.designDetails;
    let styleData = {
      // background: s360ConfigService.config.designDetails.recieverMessageColor,
      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
      // color: s360ConfigService.config.designDetails.recieverMessageFontColor,
      marginLeft: "15px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: isNullOrUndefined(designDetials.buttonBorderColor)
        ? "#0092ed"
        : designDetials.buttonBorderColor,

      borderRadius: isNullOrUndefined(designDetials.buttonBorderRadius)
        ? 20
        : designDetials.buttonBorderRadius,
      color: isNullOrUndefined(designDetials.buttonTextColor)
        ? "#0092ed"
        : designDetials.buttonTextColor,
      backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor)
        ? "#fff"
        : designDetials.buttonBackgroundColor,
    };
    return styleData;
    // return {
    //     background: s360ConfigService.config.designDetails.recieverMessageColor,
    //     fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
    //     fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
    //     color: s360ConfigService.config.designDetails.recieverMessageFontColor,
    //     marginLeft: '15px'
    // }
  };
}

export default MessageA79;
